import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";

const Main = lazy(() => import("../../components/Events/qrCode/main"));
const QRCodeTrainingConference = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default QRCodeTrainingConference;

